<template>
  <label
    :name="facetId + filter"
    class="group relative flex aspect-[175/115] w-full flex-col justify-end bg-contain p-12 pb-8"
    :class="[
      { 'bg-gradient-to-b from-grey-light-01 to-grey-dark-02': !style },
      isDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
    ]"
    :style="style"
  >
    <input
      v-model="selected"
      :value="filter"
      :disabled="isDisabled"
      type="checkbox"
      class="peer absolute inset-0 appearance-none transition duration-200 focus-visible:outline-2 focus-visible:outline-offset-4 group-hover:bg-black/15"
      :class="[
        { 'bg-white/50': isDisabled },
        isDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
      ]"
    />
    <div
      class="pointer-events-none absolute right-8 top-8 h-32 w-32 scale-75 rounded-full bg-black p-4 text-white opacity-0 transition duration-150 ease-swing focus-visible:outline-2 focus-visible:outline-offset-4 peer-checked:scale-100 peer-checked:opacity-100"
    >
      <SpriteSymbol name="check" class="h-full w-full" />
    </div>
    <span
      class="relative z-20 uppercase"
      :class="{
        'text-grey-dark-03': isDisabled,
      }"
      >{{ label }}</span
    >
  </label>
</template>

<script lang="ts" setup>
const props = defineProps<{
  facetId: string
  filter: string
  count: number
  label: string
  background?: string
}>()

const selected = defineModel<boolean | string[]>()
const isDisabled = computed(() => !props.count)

const style = computed(() => {
  if (props.background) {
    return { backgroundImage: `url(${props.background})` }
  }
})
</script>
